var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "from",
    staticStyle: {
      "padding": "0 10%"
    },
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "退住时间",
      "prop": "ssmc"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退住原因",
      "prop": "ssdz"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入楼层"
    },
    model: {
      value: (_vm.from.ssdz),
      callback: function($$v) {
        _vm.$set(_vm.from, "ssdz", $$v)
      },
      expression: "from.ssdz"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "30%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a65425","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xzgl/SstzGl/SstzGl_edit.vue
// module id = null
// module chunks = 